var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchHeaderSalesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.6471,
    height: 19,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96264 13.1026C3.63911 13.0726 3.32637 13.2127 3.15382 13.4731C2.98128 13.7235 2.98128 14.0539 3.15382 14.3143C3.32637 14.5646 3.63911 14.7148 3.96264 14.6748H12.4174C12.8477 14.6347 13.1723 14.2932 13.1723 13.8937C13.1723 13.4831 12.8477 13.1427 12.4174 13.1026H3.96264ZM12.4174 8.53528H3.96264C3.49784 8.53528 3.12147 8.88676 3.12147 9.31736C3.12147 9.74795 3.49784 10.0984 3.96264 10.0984H12.4174C12.8811 10.0984 13.2586 9.74795 13.2586 9.31736C13.2586 8.88676 12.8811 8.53528 12.4174 8.53528ZM7.18602 4H3.96264V4.01001C3.49784 4.01001 3.12147 4.3605 3.12147 4.79109C3.12147 5.22169 3.49784 5.57218 3.96264 5.57218H7.18602C7.65082 5.57218 8.02826 5.22169 8.02826 4.78008C8.02826 4.35048 7.65082 4 7.18602 4Z",
    fill: "#0071B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchHeaderSalesIcon);
export default __webpack_public_path__ + "static/media/switch_header_sales_icon.7b8d5afab16d35d88254a184ae958d4a.svg";
export { ForwardRef as ReactComponent };